import React from "react";
import { calcularInfoParcialidad } from "../utilities/historialParcial";

const VistaHistorial = ({ cargandoHistorial, historialPagos }) => {
  const infoParcialidad = calcularInfoParcialidad(historialPagos);
  // "Solicitante" solo aplica a Ex-alumnos (los alumnos regulares ya se identifican arriba).
  const hayExalumno = historialPagos.some((p) => p.exalumno);

  return (
    <div className="Dashboard-card" style={{ marginTop: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h3 style={{ margin: 0, color: '#003b5c' }}>Historial de Pagos Realizados</h3>
      </div>

      {cargandoHistorial ? (
        <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
          <p><strong>Cargando historial de pagos...</strong></p>
        </div>
      ) : historialPagos.length > 0 ? (
        <div style={{ overflowX: 'auto', border: '1px solid #ddd', borderRadius: '8px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead style={{ backgroundColor: '#f4f4f4', borderBottom: '2px solid #ddd' }}>
              <tr>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Fecha</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>ID Transacción</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Banco</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Referencia / Folio</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Conceptos</th>
                {hayExalumno && <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Solicitante</th>}
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333' }}>Método</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333', textAlign: 'right' }}>Importe</th>
                <th style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#333', textAlign: 'center' }}>Estatus</th>
              </tr>
            </thead>
            <tbody>
              {historialPagos.map((pago, index) => {
                const parcialidad = infoParcialidad(pago);
                const filaResaltada = parcialidad !== null;

                return (
                  <tr
                    key={index}
                    style={{
                      borderBottom: '1px solid #eee',
                      backgroundColor: filaResaltada ? '#fff8e1' : (index % 2 === 0 ? '#fff' : '#fcfcfc')
                    }}
                  >
                    <td style={{ padding: '12px 15px', fontSize: '0.9rem' }}>{pago.fecha_pago}</td>

                    <td style={{ padding: '12px 15px', fontSize: '0.85rem' }}>
                      {filaResaltada ? (
                        <span
                          title={`Parcial ${parcialidad.numero} de este pago (folio ${parcialidad.folio})`}
                          style={{
                            fontFamily: 'monospace', fontWeight: 'bold', color: '#8a6d00',
                            backgroundColor: '#ffe082', padding: '3px 8px', borderRadius: '10px'
                          }}
                        >
                          🔗 P{parcialidad.numero}-{parcialidad.folio}
                        </span>
                      ) : (
                        <span style={{ fontFamily: 'monospace', color: '#555' }}>{pago.id}</span>
                      )}
                    </td>

                    {/* NUEVA CELDA DINÁMICA DE BANCO/MÉTODO */}
                    <td style={{
                      padding: '12px 15px',
                      fontSize: '0.9rem',
                      fontWeight: 'bold',
                      color: pago.banco === 'BBVA' ? '#004481' :
                            (pago.banco === 'Banorte' || pago.banco === 'BANORTE') ? '#eb0029' :
                            '#00796b' // Color verde/teal para TPV (Plantel) u otros
                    }}>
                      {pago.banco}
                    </td>

                    <td style={{ padding: '12px 15px', fontSize: '0.85rem', fontFamily: 'monospace', color: '#555' }}>{pago.folio_pago}</td>
                    <td style={{ padding: '12px 15px', fontSize: '0.9rem' }}>{pago.conceptos}</td>
                    {hayExalumno && <td style={{ padding: '12px 15px', fontSize: '0.9rem', color: '#555' }}>{pago.exalumno || '—'}</td>}
                    <td style={{ padding: '12px 15px', fontSize: '0.9rem' }}>{pago.metodo_pago}</td>
                    <td style={{ padding: '12px 15px', fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'right' }}>${parseFloat(pago.importe_total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '12px 15px', textAlign: 'center' }}>
                      <span style={{ backgroundColor: '#d4edda', color: '#155724', padding: '4px 10px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 'bold' }}>
                        {pago.estatus}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#f8f9fa', border: '1px dashed #ccc', borderRadius: '8px' }}>
          <h4 style={{ color: '#555', margin: '0 0 5px 0' }}>Sin historial de pagos</h4>
          <p style={{ color: '#777', margin: 0, fontSize: '0.9rem' }}>Este alumno no cuenta con pagos registrados o validados en el sistema.</p>
        </div>
      )}
    </div>
  );
};

export default VistaHistorial;
